import React, { useEffect, useState } from 'react';
import { LeedflowLogoMinimalist as logo } from '@leedpulse-monorepo/assets';
import { ColorPicker, Flex, Form, InputNumber, QRCode, Select, Switch, Typography } from 'antd';
import { QRCodeProps } from 'antd/lib';

interface PaymentQrCodeProps {
    status: 'loading' | 'active' | 'expired' | 'scanned';
    value: string;
}

export default function PaymentQrCode({ status, value }: PaymentQrCodeProps) {
    const [qrIcon, setQrIcon] = useState<string>();

    const [showIcon, setShowIcon] = useState(true);
    const [iconSize, setIconSize] = useState(64);
    const [bgColor, setBgColor] = useState('#ffffff');
    const [errorLevel, setErrorLevel] = useState('H');

    useEffect(() => {
        const img = new Image();
        img.onload = () => {
            const scale = 4; // draw at 4x for a sharp result once scaled down
            const padding = 8 * scale;
            const radius = 12 * scale;
            const size = 64 * scale;

            const canvas = document.createElement('canvas');
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;

            ctx.beginPath();
            ctx.roundRect(0, 0, size, size, radius);
            ctx.fillStyle = '#ffffff';
            ctx.fill();
            ctx.lineWidth = 2 * scale;
            ctx.strokeStyle = '#e5e7eb';
            ctx.stroke();
            ctx.drawImage(img, padding, padding, size - padding * 2, size - padding * 2);

            setQrIcon(canvas.toDataURL());
        };
        img.src = logo;
    }, []);

    return <Flex gap={10} align="center">
        <QRCode
            status={status}
            id="payment-link-qr-code"
            type='canvas'
            errorLevel={errorLevel as QRCodeProps['errorLevel']}
            value={value}
            size={256}
            icon={showIcon ? qrIcon : undefined}
            iconSize={iconSize}
            bgColor={bgColor}
            style={{ padding: 10 }}
        />
        <Flex vertical gap={10}>
            <Flex vertical gap={4}>
                <Typography.Text strong>Affficher le logo</Typography.Text>
                <Flex>
                    <Switch checked={showIcon} onChange={setShowIcon} />
                    </Flex>
            </Flex>
            <Flex vertical gap={4}>
                <Typography.Text strong>Taille</Typography.Text>
                <InputNumber min={1} max={100} value={iconSize} onChange={(value) => setIconSize(value ?? 64)} />
            </Flex>
            <Flex vertical gap={4}>
                <Typography.Text strong>Couleur de fond</Typography.Text>
                <Flex>
                    <ColorPicker value={bgColor} onChange={(value) => setBgColor(value.toHexString())} />
                </Flex>
            </Flex>
            <Flex vertical gap={4}>
                <Typography.Text strong>Correction d'erreur</Typography.Text>
                <Select options={[
                    { label: 'Faible', value: 'L' },
                    { label: 'Moyen', value: 'M' },
                    { label: 'Fort', value: 'Q' },
                    { label: 'Maximum', value: 'H' },
                ]} value={errorLevel} onChange={(value) => setErrorLevel(value ?? 'H')} />
            </Flex>
        </Flex>
    </Flex>
}